import React, { useEffect, useState } from "react";
import { Card, Spinner } from "react-bootstrap";
import { endpoints } from "../../helpers/Endpoints";
import { api } from "../../helpers/apiCore";

interface WalletsStatsSummary {
	totalBalance: number,
	totalCredit: number,
	totalDebit: number,
	totalActiveWallets: number
}

const WalletStats = () => {

	const [walletsStatsData, setWalletsStatsData] = useState<WalletsStatsSummary | null>(null);

	useEffect(() => {
		const fetchWalletsStats = async () => {
			try {
				api.setAuthorization(api.getLoggedInUser());
				const response = await api.get(endpoints.getWalletStats, {});
				setWalletsStatsData(response.data.data);
			} catch (error) {
				console.error("Error fetching data:", error);
			}
		};
		fetchWalletsStats();
	}, []);

	const formatNumber = (number: number | bigint) => {
		return new Intl.NumberFormat().format(number);
	};

	const statsMapping = walletsStatsData ? [
		{
			title: "Total Amount in Wallets",
			value: `₦${formatNumber(walletsStatsData.totalBalance)}`,
		},
		{
			title: "Total Inflow",
			value: `₦${formatNumber(walletsStatsData.totalCredit)}`,
			className: 'wallet-inflow'
		},
		{
			title: "Total Outflow",
			value: `₦${formatNumber(walletsStatsData.totalDebit)}`,
			className: 'wallet-outflow'
		},
		{
			title: "Total Active Wallets",
			value: `${formatNumber(walletsStatsData.totalActiveWallets)}`,
		},
	] : [];

	if (!walletsStatsData) {
		return <Spinner animation="border" size="sm" />
	};

	return (
		<>
			<div className="cards-section">
				{statsMapping.map((stat, index) => (
					<Card key={index} className="stats-card">
						<Card.Body>
							<Card.Title>{stat.title}</Card.Title>
							<Card.Text className={`stats-value ${stat.className}`}>{stat.value}</Card.Text>
						</Card.Body>
					</Card>
				))}
			</div>
		</>
	)
}
export default WalletStats